import type { CaseView } from "./caseView";

/* UI-DESIGN: LB-85 public hooks come from the mystery record. Difficulty
   and first clues stay absent until sourced data exists. LB-77 role previews
   remain drafts for Avi to replace; see docs/lightbox/COPY.md. */
export type CaseProduct = {
  hook: string;
  difficulty: string | null;
  firstClue: { text: string; note: string } | null;
  /* UI-DESIGN: LB-77 (Taco: "Preview a role", not the clue). The public
     mysteries list carries no roles, so one guest's character card is
     drafted here. DRAFT for Avi: swap in a real role from the case. */
  role: { label: string; name: string; text: string; note: string } | null;
};

const keyOf = (name: string) => name.toLowerCase().replace(/[^a-z0-9]/g, "");

const DRAFT_ROLES: Record<string, NonNullable<CaseProduct["role"]>> = {
  sherlocked: {
    label: "Suspect 04",
    name: "The butler",
    text: "Twenty years in the house and he knows where every key is kept. Says he spent the whole evening polishing the silver.",
    note: "the silver was already polished",
  },
  whitelotus: {
    label: "Suspect 02",
    name: "The resort manager",
    text: "Knows every guest by name and every room by number. Swears Room 14 had one guest all week.",
    note: "front desk logged two key cards",
  },
  weekendatbernies: {
    label: "Suspect 03",
    name: "The junior accountant",
    text: "Found a few numbers that don't add up and came out for the weekend to ask Bernie about them.",
    note: "never got to ask",
  },
};

export const productFor = (view: CaseView): CaseProduct =>
  ({
    // UI-DESIGN: LB-85 public case descriptions are sourced from the mystery
    // record. Invented draft hooks and clues must not become product facts.
    hook: view.premise,
    difficulty: null,
    firstClue: null,
    // Avi still owns the explicitly documented draft role previews (LB-77).
    role: DRAFT_ROLES[keyOf(view.name)] ?? null,
  });
